<template>
  <div id="app">
    <loading v-if="!data" />
    <div v-else>
<!--      <div class="" v-if="typeof(data.lic_dop_obr) !== 'undefined'">-->
      <div class="kris-redaktor-format">
        <div class="h3">Документы спортивного клуба</div>
      </div>
      <div class="kris-documents-box">
        <ul class="kris-doclist">
<!--          <file v-if="typeof(data.lic_dop_obr) !== 'undefined'" title="Выданная общеобразовательной организации лицензия на осуществление образовательной деятельности по виду образования «дополнительное образование детей и взрослых»" ext="pdf" :link="base + data.lic_dop_obr.url"  />-->
          <file v-if="typeof(data.sport_plan) !== 'undefined'" title="План спортивно-массовых, физкультурно-спортивных и социально-значимых мероприятий на учебный год" ext="pdf" :link="base + data.sport_plan.url" />
          <file v-if="typeof (data.shedule) !== 'undefined'" title="Расписание работы спортивных секций в спортивном клубе" ext="pdf" :link="base + data.shedule.url"/>
          <file v-if="typeof (data.order) !== 'undefined'" title="Приказ о создании спортивного клуба" ext="pdf" :link="base + data.order.url"/>
          <file v-if="typeof (data.thesis) !== 'undefined'" title="Положение о спортивном клубе" ext="pdf" :link="base + data.thesis.url"/>
          <file v-if="typeof (data.protocol) !== 'undefined'" title="Протокол съезда (конференции) или общего собрания о создании спортивного клуба" ext="pdf" :link="base + data.protocol.url"/>
          <file v-if="typeof (data.state) !== 'undefined'" title="Устав спортивного клуба, принятый на съезде (конференции) или общем собрании" ext="pdf" :link="base + data.state.url"/>
        </ul>
      </div>
<!--      </div>-->
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { SET_EO_ID } from './store/mutations.types'
import { GET_SPORT_DOCS } from './store/actions.types'
import Loading from './components/Loading'
import File from './components/File'
export default {
  name: 'App',
  data () {
    return {
      base: 'https://st.educom.ru/'
    }
  },
  components: {
    loading: Loading,
    file: File
  },
  computed: {
    ...mapState({
      data: 'sportDocs'
    })
  },
  mounted () {
    this.$store.commit(SET_EO_ID, document.body.getAttribute('data-eo-id'))
    this.$store.dispatch(GET_SPORT_DOCS)
  }
}
</script>

<style lang="less">

</style>
